import { getSelectedPeriod } from "../../../../services/GroupContext";
import { addDataToExcel } from "../utils/helpers";
import { excess_debt_cap_variables, unused_variables } from "../utils/metrics";

export const getCirAttributesSection = (excelData) => {
  const selectedPeriodOfAccount = getSelectedPeriod();

  addDataToExcel(selectedPeriodOfAccount, excelData, unused_variables);
  addDataToExcel(selectedPeriodOfAccount, excelData, excess_debt_cap_variables);

  return [
    ["Unused Interest Allowance (s394)"],
    ["", "", "GBP"],
    [],
    excelData.current_int_allowance,
    [],
    excelData.current_tax_interest_expense,
    excelData.reactivations,
    excelData.current_yr_interest,
    [],
    excelData.unused_interest_gen,
    excelData.unused_interest_bf,
    [],
    [],
    ["Excess Debt Cap (s400)"],
    ["", "", "GBP"],
    excelData.excess_debt_cap_from_prior_periodEDC,
    excelData.angieorqngieEDC,
    excelData.group_debt_capEDC,
    [],
    excelData.group_debt_capEDC2,
    excelData.group_percentage_tax_ebitdaEDC,
    excelData.excess_debt_cap_generated_pre_cflimitEDC,
    [],
    excelData.excess_debt_cap_from_prior_periodEDC,
    excelData.group_disallowanceEDC,
    excelData.cflimitEDC,
    [],
    excelData.group_excess_debt_capEDC,
    [],
    [],
  ];
};
